export const MEASUREMENT_UNITS = [
  "ton/month",
  "pcs",
  "cm",
  "dz",
  "ft",
  "g",
  "in",
  "kg",
  "lbs",
  "mtr",
  "nos",
  "roll",
  "pkt",
];
